export const TagGroup = {
    Language: 1, // 開発言語スキル
    Framework: 2, //フレームワーク
    Infrastructure: 3, //インフラスキル
    Occupation: 4, //職種
    WorkArea: 5, //勤務地エリア
    UnitPrice: 6, //単価

    getName: (groupId) => {
      var name = "";
      switch (groupId) {
        case 1:
          name = "開発言語スキル";
          break;
        case 2:
          name = "フレームワーク";
          break;
        case 3:
          name = "インフラスキル";
          break;
        case 4:
          name = "職種";
          break;
        case 5:
          name = "勤務地エリア";
          break;
        case 6:
          name = "単価";
          break;
        default:
          name = "";
          break;
      }
      return name;
  },

  getList: () => {
    return [
      {
        value: TagGroup.Language,
        label: TagGroup.getName(TagGroup.Language)
      },
      {
        value: TagGroup.Framework,
        label: TagGroup.getName(TagGroup.Framework)
      },
      {
        value: TagGroup.Infrastructure,
        label: TagGroup.getName(TagGroup.Infrastructure)
      },
      {
        value: TagGroup.Occupation,
        label: TagGroup.getName(TagGroup.Occupation)
      },
      {
        value: TagGroup.WorkArea,
        label: TagGroup.getName(TagGroup.WorkArea)
      },
      {
        value: TagGroup.UnitPrice,
        label: TagGroup.getName(TagGroup.UnitPrice)
      }
    ]  
  }
}

export const Gender = {
    Male : 1,
    Female: 2,

    getName: (genderId) => {
      var name = "";
      switch (genderId) {
        case 1:
          name = "男性";
          break;
        case 2:
          name = "女性";
          break;
        default:
          name = "";
          break;
      }
      return name;
   },

   getList: () => {
    return [
      {
        value: Gender.Male,
        label: Gender.getName(Gender.Male)
      },
      {
        value: Gender.Female,
        label: Gender.getName(Gender.Female)
      }
     ]
   }
}